import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  inject,
  input,
  viewChild,
} from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, take } from 'rxjs/operators';
import { SessionStore } from '../../../core/state';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'cmg-clear2-ui-content-area-scrollable',
  templateUrl: './content-area-scrollable.component.html',
  styleUrl: './content-area-scrollable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgTemplateOutlet],
})
export class ContentAreaScrollableComponent implements OnChanges {
  private readonly _sessionStore = inject(SessionStore);

  readonly panelScroller = viewChild('panelScroller', { read: ElementRef });
  readonly scrollPosition = input<number>(undefined);
  readonly removePadding = input(false);
  readonly contentContainerClasses = input<string | Record<string, string> | null>(null);
  readonly overflowContainerClasses = input<string | Record<string, string> | null>(null);
  readonly stickyFooterClasses = input<string | Record<string, string> | null>(null);
  readonly stickyHeaderClasses = input<string | Record<string, string> | null>(null);

  mainContent = contentChild<TemplateRef<unknown>>('mainContent');
  stickyFooter = contentChild<TemplateRef<unknown>>('stickyFooter');
  stickyHeader = contentChild<TemplateRef<unknown>>('stickyHeader');

  ngOnChanges(changes: SimpleChanges) {
    const scrollPosition = this.scrollPosition();
    if (changes.scrollPosition && scrollPosition !== undefined) {
      this.scrollTo(scrollPosition);
    }
  }

  scrollTo(offsetTop: number): void {
    this._sessionStore.update({ autoScrolling: true });
    /**
     *  No end event for scrolling
     *  Therefore, check that the scroll event has finished
     */
    fromEvent(this.panelScroller().nativeElement, 'scroll')
      .pipe(
        distinctUntilChanged(),
        debounceTime(100), // wait 100 ms if no emit then scroll stopped
        take(1),
      )
      .subscribe(() => {
        this._sessionStore.update({ autoScrolling: false });
      });
    this.panelScroller().nativeElement.scroll(0 /* x-coordinate */, offsetTop - this.panelScroller().nativeElement.offsetTop);
  }
}
